Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "pagetitle2925401775",
  {"root":"pagetitle2925401775--root"},
  "",
  2,
  "pagetitle2925401775"
);

